import { createRoute } from 'utils/routes'
import LoginDev from './views/LoginPage'
import Login from './views/Login'
import Logout from './views/Logout'
import EnterEvent from './views/EnterEvent'
import ActivationUser from './components/ActivationUser'

export default {
    enterEvent: createRoute<{ eventSlug: string }>({
        title: 'Event Entry',
        path: '/:eventSlug/enterevent/',
        component: EnterEvent,
        isPublic: true,
        context: 'enter-event'
    }),
    loginDev: createRoute({
        title: 'Login',
        path: '/login',
        component: LoginDev,
        isPublic: true,
        context: 'login-dev'
    }),
    login: createRoute({
        title: 'Login',
        path: '/',
        component: Login,
        exact: true,
        context: 'login',
        isPublic: true,
    }),
    logout: createRoute({
        title: 'Logout',
        path: '/logout',
        component: Logout,
        isPublic: true,
        context: 'logout'
    }),
    activationUser: createRoute({
        title: 'Activation User',
        path: '/activate/:activationKey',
        component: ActivationUser,
        isPublic: true,
        exact: true,
        context: 'activate-user'
    }),
}
